import classNames from 'classnames';

import { useMemo } from 'react';
import useStyles from './styles';
import type { CategoryRowsSkeletonProps } from './types';

const ROW_COUNT = 4;

const CategoryRowsSkeleton = ({ itemsPerRow }: CategoryRowsSkeletonProps) => {
  const classes = useStyles();
  const rows = useMemo(
    () => Array.from({ length: ROW_COUNT }, (_, index) => index),
    []
  );
  const cells = useMemo(
    () => Array.from({ length: itemsPerRow }, (_, index) => index),
    [itemsPerRow]
  );

  return (
    <div className={classes.container}>
      {rows.map((rowIndex) => (
        <section key={`row-${rowIndex}`} className={classes.section}>
          <div className={classes.header}>
            <div className={classNames(classes.shimmer, classes.titleBar)} />
            <div className={classNames(classes.shimmer, classes.seeAll)} />
          </div>
          <div className={classes.row}>
            {cells.map((cellIndex) => (
              <div
                key={`cell-${rowIndex}-${cellIndex}`}
                className={classNames(classes.shimmer, classes.cell)}
              />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default CategoryRowsSkeleton;
